import { render, staticRenderFns } from "./RedirectSettingAdd.vue?vue&type=template&id=33cab738"
import script from "./RedirectSettingAdd.vue?vue&type=script&lang=js"
export * from "./RedirectSettingAdd.vue?vue&type=script&lang=js"
import style0 from "./RedirectSettingAdd.vue?vue&type=style&index=0&id=33cab738&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports